import { Outlet } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import MobileSidebar from "../components/layout/MobileSodebar";

export default function MaxLayout() {

  return (
    <div
      className="flex h-screen items-stretch overflow-hidden"
      style={{ background: "linear-gradient(225deg, #1A0E3E 30%, #4F2A71 75%, #904DB0 100%)" }}
    >
      {/* Desktop sidebar — hidden below md (991px) */}
      <div
        className="max-md:hidden flex-shrink-0 h-full overflow-y-auto"
        style={{ width: "250px" }}
      >
        <Sidebar />
      </div>

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
        {/* Mobile top bar — only below md */}
        <div
          className="md:hidden flex items-center px-4 py-3 flex-shrink-0"
          style={{ background: "linear-gradient(180deg, #1A0E3E 0%, #4F2A71 100%)" }}
        >
          <MobileSidebar />
          <p className="font-roboto font-bold text-white uppercase tracking-widest text-sm ml-3">
            ADMIN PANEL
          </p>
        </div>

        {/* Page content */}
        <div className="flex-1 flex flex-col overflow-hidden bg-[#F0EEF8] p-3 min-h-0">
          <div className="bg-white rounded-2xl flex-1 overflow-hidden flex flex-col min-h-0">
            <div className="flex-1 overflow-hidden flex flex-col min-h-0">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
